common.View.create('common.canvas.blocks.custom.category.Block', {

    onDOMLoad() {
        this.initSize();
    },

    initSize() {

    }
});